import { useCustomer } from "@/contexts/CustomerContext";
import { useAddressAutocomplete } from "@/contexts/useAddressContext";
import { useMerchantSlug } from "@/utils/hooks/useMerchantSlug";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CustomerProfile from "./CustomerProfile";
import { useUpdateCustomerProfileMutation } from "@/store/api/userApi";

const CustomerRegister = () => {
  const { login } = useCustomer();
  const [form, setForm] = useState({
    name: "",
    avatar: "",
    email: "",
    phone: "",
    wallet_points: "0.00",
  });
  const merchantSlug = useMerchantSlug();
  const { address, handlePlaceSelected, handleInputChange } =
    useAddressAutocomplete({
      street: "",
      city: "",
      province: "",
      country: "",
      postal_code: "",
    });

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [updateCustomerProfile] = useUpdateCustomerProfileMutation();
  useEffect(() => {
    if (!searchParams.has("phone")) {
      navigate(`${merchantSlug}/customer-register`);
      return;
    }
    setForm((prev) => ({
      ...prev,
      phone: `+${searchParams.get("phone")}`,
    }));
  }, [navigate, searchParams]);

  const normalizePhoneNumber = (phone: string) => {
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `+${cleaned}`;
    }
    if (cleaned.length === 10) {
      return `+1${cleaned}`;
    }
    return phone;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const normalizedPhone = normalizePhoneNumber(form.phone);
    const data = {
      ...form,
      street: address.street || "",
      city: address.city || "",
      province: address.province || "",
      postal_code: address.postal_code || "",
      country: address.country ?? "",
      state: address.province ?? "",
      pincode: address.postal_code ?? "",
      phone: normalizedPhone,
    };
    await updateCustomerProfile(data).unwrap();
    login(data);
    navigate(`${merchantSlug}/customer-profile`);
  };

  return (
    <div className="mt-4">
      <div className="ml-4">
        <Link to={`${merchantSlug}`} className="text-blue-500 hover:underline">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </Link>
      </div>
      <CustomerProfile
        handleSubmit={handleSubmit}
        form={form}
        setForm={setForm}
        address={address}
        handlePlaceSelected={handlePlaceSelected}
        handleInputChange={handleInputChange}
      />
    </div>
  );
};

export default CustomerRegister;
